<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCommercialDashboardStore } from '@/stores/useCommercialDashboardStore'
import { formatAmount, memberFullName } from './dashboardFormat'

const store = useCommercialDashboardStore()
const { teamData } = storeToRefs(store)
</script>

<template>
  <div v-if="teamData" class="card bg-base-100 shadow">
    <div class="card-body p-0">
      <table class="table table-zebra">
        <thead>
          <tr>
            <th>Commercial</th>
            <th class="text-right">Clients</th>
            <th class="text-right">CA facturé</th>
            <th class="text-right">Impayés</th>
            <th class="text-right">Renouvellements</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="member in teamData.members" :key="member.user.uuid">
            <td>
              <div class="font-semibold">{{ memberFullName(member.user) }}</div>
              <div class="text-xs text-base-content/50">{{ member.user.bu ?? '—' }}</div>
            </td>
            <td class="text-right">{{ member.stats.kpis.totalClients }}</td>
            <td class="text-right font-medium">{{ formatAmount(member.stats.kpis.totalInvoiced) }}</td>
            <td class="text-right">
              <span
                :class="member.stats.kpis.totalOutstanding > 0 ? 'text-error font-semibold' : 'text-base-content/40'"
              >
                {{ member.stats.kpis.totalOutstanding > 0 ? formatAmount(member.stats.kpis.totalOutstanding) : '—' }}
              </span>
            </td>
            <td class="text-right">
              <span v-if="member.stats.renewals.length > 0" class="badge badge-error badge-sm">
                {{ member.stats.renewals.length }}
              </span>
              <span v-else class="text-base-content/40">—</span>
            </td>
            <td>
              <button
                class="btn btn-ghost btn-xs"
                @click="store.fetchMemberDashboard(member.user.uuid)"
              >
                Voir
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
